import React, { useState } from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Testimonial from '../Testimonial';
import Div from '../Div';
import Spacing from '../Spacing';
const testimonialData = [
  {
    testimonialThumb: '/images/DP2.jpg',
    testimonialText:
      'Jaleel is an absolute pleasure to work with. Whatever project we have worked together on he has not only brought his incredible editing virtuosity but also his vibrant creative energy. Highly recommend!',
    avatarName: 'Hannah Martin',
    avatarDesignation: 'Award-Winning Athlete & Professional Dancer | CEO, Make It Happen Academy',
    ratings: '5',
  },
  {
    testimonialThumb: '/images/DP1.jpg',
    testimonialText:
      'Vox Motion made the whole video process super easy. Jaleel just got what we were going for and turned it into something clean and professional. Really happy with how it all turned out.',
    avatarName: 'Sándor Bárány',
    avatarDesignation: 'CEO | AI GALAXY',
    ratings: '4.5',
  },
  {
    testimonialThumb: '/images/DP3.jpg',
    testimonialText:
      'I’m really impressed with the quality Vox Motion delivered and the professionalism of the team. Despite the complexity of the project and multiple teams working at once, they pulled it off seamlessly. Highly recommended!',
    avatarName: 'Alex Aiono',
    avatarDesignation: 'Musician',
    ratings: '4.5',
  },
  {
    testimonialThumb: '/images/DP4.jpg',
    testimonialText:
      'These guys totally nailed the edit. They took my rough ideas and turned them into something that just worked right on vibe. Super easy to work with too. Would happily team up again! Bravo!',
    avatarName: 'Zach King',
    avatarDesignation: 'Youtuber',
    ratings: '4.5',
  },
];

export default function TestimonialSlider() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  return (
    <>
      <Div className="cs-gradient_bg_1 cs-shape_wrap_3 cs-parallax">
        <Spacing lg="130" md="80" />
        <Div className="cs-shape_3 cs-to_up">
          <img src="/images/shape_1.svg" alt="Shape" />
        </Div>
        <Div className="container">
          <Div className="cs-testimonial_slider">
            <Div className="cs-testimonial_slider_left">
              <Slider
                asNavFor={nav1}
                ref={slider2 => setNav2(slider2)}
                slidesToShow={3}
                swipeToSlide={true}
                focusOnSelect={true}
                centerMode={true}
                centerPadding="0px"
                arrows={false}
              >
                {testimonialData.map((item, index) => (
                  <Div className="slider-nav_item" key={index}>
                    <Div className="cs-rotate_img">
                      <Div className="cs-rotate_img_in">
                        <img src={item.testimonialThumb} alt="Thumb" />
                      </Div>
                    </Div>
                  </Div>
                ))}
              </Slider>
            </Div>
            <Div className="cs-testimonial_slider_right">
              <Slider
                asNavFor={nav2}
                ref={slider1 => setNav1(slider1)}
                prevArrow={<SlickArrowLeft />}
                nextArrow={<SlickArrowRight />}
                className="cs-arrow_style1"
              >
                {testimonialData.map((item, index) => (
                  <Div key={index}>
                    <Testimonial
                      testimonialText={item.testimonialText}
                      avatarName={item.avatarName}
                      avatarDesignation={item.avatarDesignation}
                      ratings={item.ratings}
                    />
                  </Div>
                ))}
              </Slider>
            </Div>
          </Div>
        </Div>
        <Spacing lg="130" md="80" />
      </Div>
    </>
  );
}
